export enum ReportDateTypeEnum {
  YESTERDAY = 'YESTERDAY',
  SEVENDAY = 'SEVENDAY',
  THIRTYDAY = 'THIRTYDAY',
}

export enum FinancialTypeEnum {
  /** 按日 */
  DAY = 'day',
  /** 按月 */
  MONTH = 'month',
}
// 财务报表导出url
export const FinancialTypeUrlMap = {
  [FinancialTypeEnum.DAY]: '/revenue/statisticsResultByDay/export',
  [FinancialTypeEnum.MONTH]: '/revenue/statisticsResultByMonth/export',
};

export enum ManageFinancialTypeEnum {
  /** 按日 */
  DAY = 1,
  /** 按月 */
  MONTH = 2,
}
